export default {
  internalRequest: {
    itself: 'Internal request',
    plural: {
      itself: 'Internal requests',
    },
    createNewRequest: 'Create new internal request',
    saveRequest: 'Save the internal request',
    backToList: 'Back to list',
    nextStep: 'Next step',
    saveAsDraft: 'Save as draft',
    submitForApproval: 'Submit for approval',
    validationErrors: 'Please check the highlighted fields.',
    calculatedHint: 'Automatically calculated',
    createRequest: 'Create {{type}} Request',
    selectType: {
      itself: 'Request type',
      placeholder: 'Select request type',
      required: 'Request type is required',
    },
    attributes: {
      project: 'Project',
      requestType: 'Request type',
      title: {
        itself: 'Title',
        required: 'Title is required',
        placeholder: 'e.g., Office Supplies for October',
      },
      additionalNote: {
        itself: 'Additional Note',
        placeholder: 'Provide additional notes about this request...',
      },
      amount: {
        itself: 'Amount',
      },
      currency: {
        itself: 'Currency',
        placeholder: 'Select option',
      },
      neededBy: {
        itself: 'Needed by',
        placeholder: 'dd/mm/yyyy',
      },
      costCategory: {
        itself: 'Cost category',
        placeholder: 'Select cost category',
        travel: 'Travel',
        accommodation: 'Accommodation',
        materials: 'Materials',
        services: 'Services',
        equipment: 'Equipment',
        other: 'Other',
      },
      linkedTicket: {
        itself: 'Ticket',
        placeholder: 'Select ticket (optional)',
      },
      linkedProcurement: {
        itself: 'Procurement',
        placeholder: 'Select procurement (optional)',
      },
      assignedTo: {
        itself: 'Assigned to',
        placeholder: 'Select HQ user',
        required: 'Assignment to HQ user is required',
      },
      attachments: {
        itself: 'Attachments',
        upload: 'Upload attachments',
        required: 'At least one attachment is required',
      },
      status: {
        draft: 'Draft',
        submitted: 'Submitted',
        opened: 'Submitted',
        approved: 'Approved',
        pendingClosed: 'Pending close',
        rejected: 'Rejected',
        closed: 'Closed',
        all: 'All',
      },
      type: {
        expenseReimbursement: 'Expense reimbursement',
        interestFreeLoan: 'Interest-free loan',
        cashAdvance: 'Cash advance',
        extraWorkApproval: 'Extra work approval',
        overtimeWorkRequest: 'Overtime work request',
        materialsRequest: 'Materials request',
        leaveRequest: 'Leave request',
        financialRequest: 'Financial request',
      },
    },
    table: {
      requestId: 'Request ID',
      project: 'Project',
      type: 'Type',
      title: 'Title',
      status: 'Status',
      amount: 'Amount',
      createdBy: 'Created by',
      date: 'Date',
      approver: 'Approver',
      created: 'Created',
      opened: 'Opened',
      updated: 'Updated',
      actions: 'Actions',
    },
    filters: {
      status: 'Status',
      allTypes: 'All Types',
    },
    types: {
      expenseReimbursement: {
        title: 'Expense reimbursement',
        description:
          'Submit expenses for reimbursement. Requires uploading receipts or invoices.',
      },
      interestFreeLoan: {
        title: 'Interest-free loan',
        description:
          'Request an interest-free loan. Subject to approval and repayment terms.',
      },
      cashAdvance: {
        title: 'Cash advance',
        description: 'Request a cash advance for travel or field work.',
      },
      extraWorkApproval: {
        title: 'Extra work approval',
        description: 'Request approval for additional work or services.',
      },
      overtimeWorkRequest: {
        title: 'Overtime work request',
        description: 'Request approval for overtime and weekend work.',
      },
      materialsRequest: {
        title: 'Materials request',
        description: 'Request materials and resources for the project.',
      },
      financialRequest: {
        title: 'Financial request',
        description:
          'Submit a financial request such as loan, salary advance, or recruitment bonus.',
        subType: 'Sub-type',
        subTypes: {
          loanRequest: 'Loan request',
          salaryAdvance: 'Salary advance',
          recruitmentBonus: 'Recruitment bonus',
        },
        requestedAmount: 'Requested amount',
        forMonth: 'For the month',
        numberOfInstallments: 'Number of monthly installments',
        monthlyInstallmentAmount: 'Monthly installment amount',
        referredPersonName: 'Referred person name',
        referredPersonRole: 'Referred person role',
        bonusAmount: 'Bonus amount',
        monthsLabel: 'months',
        repaymentEndDate: 'Last installment',
      },
      leaveRequest: {
        title: 'Vacation leave request',
        description:
          'Submit a vacation leave request with employee details and period.',
        employeeLastName: 'Last name',
        employeeFirstName: 'First name',
        employeeRole: 'Role',
        numberOfDays: 'Number of days',
        periodStart: 'Start date',
        periodEnd: 'End date',
        replacementPerson: 'Replacement person',
        approvedDays: 'Approved days',
        annualLeaveDays: 'Annual leave days',
        usedLeaveDays: 'Used leave days',
        remainingLeaveDays: 'Remaining leave days',
        approverNotes: 'Approver notes',
        employeeName: 'Employee name',
        daysUnit: 'days',
        selectFromProject: 'Select from project',
        enterManually: 'Enter manually',
        employee: 'Employee',
      },
    },
    expenseReimbursement: {
      title: 'Expense details',
      subtitle: 'Submit expenses for reimbursement',
      claimPeriodStart: {
        itself: 'Start date',
        placeholder: 'Select start date',
        required: 'Start date is required',
      },
      claimPeriodEnd: {
        itself: 'End date',
        placeholder: 'Select end date',
        invalid: 'End date must be after start date',
        required: 'End date is required',
      },
      paymentMethod: {
        itself: 'Payment method',
        placeholder: 'Select payment method',
        companyCard: 'Company card',
        personalCashCard: 'Personal cash/card',
        companyCash: 'Company cash',
      },
      expenseItems: 'Expenses',
      addLineItem: 'Add expense',
      addExpenseItem: 'Add Expense Item',
      editExpenseItem: 'Edit Expense Item',
      totalExpenses: 'Total Expenses',
      advanceAmount: {
        itself: 'Advance Amount',
        min: 'Advance amount cannot be negative',
      },
      toReceive: 'To Receive',
      toReturn: 'To Return',
      settlement: {
        itself: 'Settlement',
        toReceive: 'To receive (reimbursement)',
        toReturn: 'To return (unused funds)',
      },
      notes: 'Additional notes',
      notesPlaceholder: 'Add notes or observations...',
      table: {
        docNumber: 'Doc no.',
        date: 'Date',
        issuer: 'Issuer',
        issuerPlaceholder: 'Vendor name',
        description: 'Description',
        descriptionPlaceholder: 'Description',
        unitOfMeasure: 'U.M.',
        unitOfMeasurePlaceholder: 'pcs',
        quantity: 'Qty',
        unitPrice: 'Unit price',
        amount: 'Amount',
      },
      lineItems: {
        required: 'At least one expense item is required',
      },
      lineItemAttachments: 'Attachments',
      documentNumber: {
        required: 'Document number is required',
        numbersOnly: 'Only numbers are allowed',
      },
      documentDate: {
        required: 'Date is required',
      },
      issuer: {
        required: 'Issuer is required',
      },
      description: {
        required: 'Description is required',
      },
      unitOfMeasure: {
        required: 'Unit of measure is required',
      },
      quantity: {
        required: 'Quantity is required',
        min: 'Quantity must be at least 1',
      },
      unitPrice: {
        required: 'Unit price is required',
        positive: 'Unit price must be greater than 0',
      },
      emptyState: {
        title: 'No expense items yet',
        message: 'Add your first expense item to track your expenses',
      },
    },
    interestFreeLoan: {
      title: 'Loan details',
      subtitle: 'Interest-free loan request',
      requestedAmount: 'Requested amount',
      repaymentDurationMonths: 'Repayment duration',
      durationHint: 'Number of months for loan repayment',
      numberOfInstallments: 'Number of monthly installments',
      monthlyInstallmentAmount: 'Monthly installment',
      installmentHint: 'equal monthly installments',
      startMonth: 'Start date',
      startMonthPlaceholder: 'Select start date',
      startMonthHint: 'Date when repayment begins',
      reason: 'Reason',
      reasonPlaceholder: 'Describe the reason for this loan request...',
      maxAmount: 'Maximum amount: 10,000 RON',
      minDuration: 'Repayment duration must be at least 1 month',
      overLimitWarning:
        'The requested amount exceeds the maximum limit of 10,000 RON!',
      totalLoan: 'Total loan amount',
      monthsLabel: 'months',
    },
    cashAdvance: {
      title: 'Cash advance details',
      subtitle: 'Cash advance request for expenses',
      purpose: {
        itself: 'Purpose',
        placeholder: 'Select purpose',
        travel: 'Travel',
        accommodation: 'Accommodation',
        perDiem: 'Per diem',
        materials: 'Materials',
      },
      location: {
        itself: 'Location',
        placeholder: 'Bucharest, Cluj-Napoca...',
      },
      period: 'Period',
      startDate: {
        itself: 'Start date',
        placeholder: 'Select start date',
      },
      endDate: {
        itself: 'End date',
        placeholder: 'Select end date',
        invalid: 'End date must be after start date',
      },
      beneficiaryPersons: {
        itself: 'Beneficiary persons',
        placeholder: 'John Doe, Jane Smith...',
      },
      beneficiaryPersonsHint: 'Separate names with comma',
      beneficiaryRoles: {
        itself: 'Beneficiary roles',
        placeholder: 'Technician, Engineer...',
      },
      beneficiaries: {
        itself: 'Beneficiary persons',
        name: 'Name',
        namePlaceholder: 'John Doe',
        role: 'Role',
        rolePlaceholder: 'Technician',
      },
      addBeneficiary: 'Add person',
      amountPerPerson: 'Amount per person',
      totalAmount: 'Total amount',
      totalHint: 'Automatically calculated',
      totalAdvance: 'Total advance requested',
    },
    extraWorkApproval: {
      title: 'Extra work approval details',
      subtitle: 'Request approval for additional work',
      subType: {
        label: 'Type',
        required: 'Type is required',
        overtimeHours: 'Over time hours',
        financialItem: 'Financial Item',
      },
      hasFinancialItems: {
        label: 'Has Financial Items',
      },
      beneficiaryEntity: {
        itself: 'Beneficiary entity',
        placeholder: 'Beneficiary / entity name',
      },
      workDescription: {
        itself: 'Work description',
        placeholder:
          'Describe in detail the additional work that requires approval...',
      },
      documents: 'Available documents',
      hasEstimate: 'Estimate attached',
      hasBeneficiaryApproval: 'Beneficiary approval',
      requestedTotalAmount: 'Total requested amount',
      requestedAmount: 'Requested amount',
      approvedAmount: 'Approved amount',
      attachmentsHint:
        'Attach the estimate, beneficiary approval, and any other relevant documents for the extra work.',
      workers: {
        itself: 'Workers',
        emptyState: {
          title: 'No workers yet',
          message: 'Add your first worker to track labor costs',
        },
      },
      addWorker: 'Add Worker',
      editWorker: 'Edit Worker',
      table: {
        lastName: 'Last Name',
        firstName: 'First Name',
        role: 'Role',
        amount: 'Amount',
      },
      financialData: {
        itself: 'Financial Data',
        emptyState: {
          title: 'No financial data yet',
          message: 'Add financial data to track estimates and invoices',
        },
      },
      addFinancialItem: 'Add Financial Item',
      financial: {
        documentNumber: 'Document No.',
        documentDate: 'Document Date',
        documentNumberDate: 'Document No. / Date',
        valueWithoutVat: 'Value (excl. VAT)',
        invoiceNumber: 'Invoice No.',
        invoiceDate: 'Invoice Date',
        invoiceNumberDate: 'Invoice No. / Date',
        isInvoiced: 'Invoiced',
        isCollected: 'Collected',
        paymentStatus: 'Payment status',
        invoiced: 'Facturat',
        collected: 'Incasat',
      },
      totalWorkerAmount: 'Total amount',
      totalFinancialValue: 'Total value (excl. VAT)',
    },
    overtimeWorkRequest: {
      title: 'Overtime work details',
      subtitle: 'Overtime / weekend work request',
      workDescription: {
        itself: 'Activity description',
        placeholder: 'Describe the activities to be performed...',
      },
      period: 'Period',
      startDate: {
        itself: 'Start date',
        placeholder: 'Select start date',
        required: 'Start date is required',
      },
      endDate: {
        itself: 'End date',
        placeholder: 'Select end date',
      },
      periodHint: 'For a single day, select the same date',
      workDate: {
        itself: 'Work date',
        placeholder: 'Select date',
      },
      hours: 'Hours',
      rate: 'Rate',
      peopleList: {
        itself: 'People list',
        placeholder:
          'List of people working overtime:\n- Name, role, hours, rate\n- ...',
      },
      peopleListHint: 'Enter name, role, and hours for each person',
      people: {
        itself: 'People list',
        name: 'Name',
        namePlaceholder: 'John Doe',
        role: 'Role',
        rolePlaceholder: 'Technician',
      },
      addPerson: 'Add person',
      totalRequestedAmount: 'Total requested',
      totalHint: 'Calculated: Hours × Rate',
      totalCost: 'Estimated total cost',
    },
    materialsRequest: {
      title: 'Materials request details',
      subtitle: 'Request materials and resources',
      lineItems: 'Materials list',
      addLineItem: 'Add material',
      addMaterial: 'Add Material',
      editMaterial: 'Edit Material',
      itemCount: 'Items',
      grandTotal: 'Total value',
      table: {
        itemName: {
          itself: 'Item name',
          placeholder: 'Material name',
        },
        description: {
          itself: 'Description',
          placeholder: 'Enter description',
        },
        unitOfMeasure: 'U.M.',
        quantity: 'Quantity',
        unitPrice: 'Unit price (excl. VAT)',
        totalPrice: 'Total',
        supplierLink: {
          itself: 'Supplier link',
          placeholder: 'https://...',
        },
      },
      viewLink: 'View link',
      emptyState: {
        title: 'No materials items yet',
        message: 'Add materials items to this request',
        nonDraftTitle: 'No materials items',
      },
      totalMaterialsCost: 'Total Materials Cost',
    },
    // Used by InternalRequestCreateForm and EditDraftModal — types.leaveRequest.* is used by detail/admin views
    leaveRequest: {
      employeeLastName: 'Last name',
      employeeFirstName: 'First name',
      employeeRole: 'Role',
      numberOfDays: 'Number of days',
      periodStart: 'Start date',
      periodEnd: 'End date',
      replacementPerson: 'Replacement person',
      employee: 'Employee',
      selectFromProject: 'Select from project',
      enterManually: 'Enter manually',
    },
    financialRequest: {
      subType: {
        label: 'Sub-type',
        loanRequest: 'Loan request',
        salaryAdvance: 'Salary advance',
        recruitmentBonus: 'Recruitment bonus',
      },
      requestedAmount: 'Requested amount',
      forMonth: 'For the month',
      numberOfInstallments: 'Number of monthly installments',
      monthlyInstallmentAmount: 'Monthly installment amount',
      referredPersonName: 'Referred person name',
      referredPersonRole: 'Referred person role',
      bonusAmount: 'Bonus amount',
    },
    attachments: 'Attachments',
    uploadAttachments: 'Upload attachments',
    noAttachments: 'No attachments',
    untitled: 'Untitled Request',
    information: 'Information',
    type: 'Type',
    amount: 'Amount',
    statuses: {
      draft: 'Draft',
      submitted: 'Submitted',
      opened: 'Submitted',
      approved: 'Approved',
      pendingClosed: 'Pending close',
      rejected: 'Rejected',
      closed: 'Closed',
    },
    activity: {
      created: 'Created',
      submitted: 'Submitted',
      approved: 'Approved',
      rejected: 'Rejected',
      edited: 'Updated',
      attachmentAdded: 'Updated',
      commentAdded: 'Updated',
      closed: 'Closed',
      assigned: 'Updated',
      mfApproved: 'MF Approved',
      updated: 'Updated',
      createdDescription: 'Request is created',
      submittedDescription: 'Request submitted for approval',
      resubmitted: 'Resubmitted',
      resubmittedDescription: 'Request resubmitted for approval',
      approvedDescription: 'Request is approved',
      rejectedDescription: 'Request is rejected',
      mfApprovedDescription: 'Request is MF approved',
      assignedDescription: 'Assigned to {{name}}',
      closedDescription: 'Payment reference: {{reference}}',
      closedDescriptionGeneric: 'Request is closed',
      addExpenseItems: 'Added {{count}} expense item(s)',
      updateExpenseItem: 'Updated expense item',
      deleteExpenseItem: 'Deleted expense item',
      addMaterialsItems: 'Added {{count}} materials item(s)',
      addWorkers: 'Added {{count}} worker(s)',
      updateWorker: 'Updated worker',
      deleteWorker: 'Deleted worker',
      addFinancialItems: 'Added {{count}} financial item(s)',
      updateFinancialItem: 'Updated financial item',
      deleteFinancialItem: 'Deleted financial item',
      attachmentRemoved: 'Updated',
      updatesCount: '{{count}} updates',
      updatesBy: '{{count}} updates by {{name}}',
      rejectedNoReason: 'No rejection reason provided',
      notifications: {
        created: 'created',
        submitted: 'submitted',
        approved: 'approved',
        rejected: 'rejected',
        pendingClosed: 'pending close',
        closed: 'closed',
      },
      scope: {
        requestCreated: 'Request created',
        requestUpdated: 'Request updated.',
        expenseItemsAdded: 'Add Expense Item',
        expenseItemUpdated: 'Update Expense Item',
        expenseItemDeleted: 'Delete Expense Item',
        materialItemsAdded: 'Add Material Item',
        materialItemUpdated: 'Update Material Item',
        materialItemDeleted: 'Delete Material Item',
        workersAdded: 'Add Worker Item',
        workerUpdated: 'Update Worker Item',
        workerDeleted: 'Delete Worker Item',
        financialItemsAdded: 'Add Financial Item',
        financialItemUpdated: 'Update Financial Item',
        financialItemDeleted: 'Delete Financial Item',
      },
    },
    generalInformation: 'General information',
    'generalInformation.subtitle': 'Basic information about the request',
    hqApprovalQueue: {
      title: 'HQ approval queue',
      description: 'Review and approve internal requests from all projects',
      emptyOpened: {
        title: 'No pending approvals',
        subtitle: "You'll be notified when new requests need your approval",
      },
      emptyApproved: {
        title: 'No requests awaiting second approval',
        subtitle: 'Requests pending MF approval will appear here',
      },
    },
    accountingQueue: {
      title: 'Internal Requests',
      description: 'Review and close internal requests awaiting payment',
      emptyPending: {
        title: 'All caught up!',
        subtitle: "You'll be notified when new requests need your attention",
      },
      emptyClosed: {
        title: 'No closed requests yet',
        subtitle: 'Requests you close will appear here',
      },
    },
    tabs: {
      requiresAttention: 'Requires Attention',
      submitted: 'Submitted',
      approved: 'Approved',
      pendingClose: 'Pending Close',
      closed: 'Closed',
      rejected: 'Rejected',
    },
    adminQueue: {
      emptyRequiresAttention: {
        title: 'All caught up!',
        subtitle: 'No requests currently need your attention',
      },
      emptySubmitted: {
        title: 'No submitted requests',
        subtitle: 'Submitted requests will appear here',
      },
      emptyApproved: {
        title: 'No approved requests',
        subtitle: 'Approved requests awaiting further action will appear here',
      },
      emptyPendingClose: {
        title: 'No requests pending close',
        subtitle: 'Requests awaiting closure will appear here',
      },
      emptyClosed: {
        title: 'No closed requests',
        subtitle: 'Closed requests will appear here',
      },
      emptyRejected: {
        title: 'No rejected requests',
        subtitle: 'Rejected requests will appear here',
      },
      empty: {
        title: 'No requests found',
        subtitle: 'Internal requests will appear here',
      },
      seeAll: 'See All',
    },
    error: {
      loading: 'Error loading internal request',
    },
    actions: {
      send: 'Send',
      edit: 'Edit',
      delete: 'Delete',
      approve: 'Approve',
      reject: 'Reject',
      mfApprove: 'Approve',
      close: 'Close',
    },
    rejectReason: 'Rejection reason (optional)',
    rejectReasonPlaceholder: 'Enter a reason for rejection...',
    confirmModals: {
      confirmRejectMessage: 'Are you sure you want to reject this {{type}}?',
      rejectReasonPlaceholder: 'Enter a reason for rejection...',
      reasonRequired: 'A reason is required',
      cancel: 'No, cancel',
      confirmReject: 'Yes, reject!',
      confirmApproveMessage: 'Are you sure you want to approve this {{type}}?',
      confirmApprove: 'Yes, approve!',
      confirmMfApproveMessage:
        'Are you sure you want to approve this {{type}}? (2nd level)',
      confirmMfApprove: 'Yes, approve!',
      approveAmountLabel: 'Amount to approve',
      approveAmountDisplay: 'Total amount',
      approveAmountRequired: 'A valid amount is required',
      approvedDaysRequired: 'Approved days is required and must be at least 1',
      invalidNumber: 'Must be a valid non-negative number',
      approverNotesLabel: 'Approver notes',
      approverNotesPlaceholder: 'Enter notes for this approval...',
      resubmissionNoteTitle: 'Resubmission note',
      resubmissionNotePlaceholder:
        'Explain what changed since the rejection...',
      resubmissionNoteRequired: 'Resubmission note is required',
      resubmissionNoteConfirm: 'Resubmit',
      actionCommentTitle: 'Comment (optional)',
      actionCommentPlaceholder: 'Add any context for this action...',
      actionCommentConfirm: 'Confirm',
    },
    messages: {
      submittedSuccess: 'Request submitted successfully',
      submitError: 'Error submitting request',
      approvedSuccess: 'Request approved successfully',
      approveError: 'Error approving request',
      rejectedSuccess: 'Request rejected successfully',
      rejectError: 'Error rejecting request',
      mfApprovedSuccess: 'Request MF approved successfully',
      mfApproveError: 'Error MF approving request',
      closedSuccess: 'Request closed successfully',
      closeError: 'Error closing request',
      selectHqUser: 'Please select an HQ user to assign this request to',
      lineItemAdded: 'Item added successfully',
      lineItemUpdated: 'Item updated successfully',
      lineItemDeleted: 'Item deleted successfully',
      lineItemError: 'Error saving item',
      draftUpdated: 'Draft updated successfully',
      updateError: 'Error updating request',
      draftDeleted: 'Draft deleted successfully',
      deleteError: 'Error deleting request',
      exportDocumentError: 'Failed to export document',
    },
    assignToHqUser: 'Assign to HQ user',
    assignToNextHqUser: 'Assign to next HQ user',
    details: 'Details',
    createdAt: 'Created at',
    requestedBy: 'Requested by',
    approver: 'Approver',
    neededByDate: {
      itself: 'Needed by',
    },
    description: {
      itself: 'Description',
    },
    requestedAmount: {
      itself: 'Requested amount',
    },
    noDetails: 'No additional details available',
    claimPeriodStart: {
      itself: 'Claim period start',
    },
    claimPeriodEnd: {
      itself: 'Claim period end',
    },
    totalAmount: {
      itself: 'Total amount',
    },
    advanceReceived: {
      itself: 'Advance received',
    },
    lineItem: {
      description: {
        itself: 'Description',
      },
      amount: {
        itself: 'Amount',
      },
      date: {
        itself: 'Date',
      },
      name: {
        itself: 'Name',
      },
      quantity: {
        itself: 'Quantity',
      },
      unit: {
        itself: 'Unit',
      },
      estimatedCost: {
        itself: 'Estimated cost',
      },
    },
    loanPurpose: {
      itself: 'Loan purpose',
    },
    repaymentDurationMonths: {
      itself: 'Repayment duration',
    },
    numberOfInstallments: {
      itself: 'Number of installments',
    },
    monthlyInstallmentAmount: {
      itself: 'Monthly installment',
    },
    startMonth: {
      itself: 'Start date',
    },
    purpose: {
      itself: 'Purpose',
    },
    expectedReturnDate: {
      itself: 'Expected return date',
    },
    workDescription: {
      itself: 'Work description',
    },
    justification: {
      itself: 'Justification',
    },
    estimatedCost: {
      itself: 'Estimated cost',
    },
    startDate: {
      itself: 'Start date',
    },
    endDate: {
      itself: 'End date',
    },
    workDate: {
      itself: 'Work date',
    },
    startTime: {
      itself: 'Start time',
    },
    endTime: {
      itself: 'End time',
    },
    totalHours: {
      itself: 'Total hours',
    },
    reason: {
      itself: 'Reason',
    },
    urgencyLevel: {
      itself: 'Urgency level',
    },
    deliveryLocation: {
      itself: 'Delivery location',
    },
    activityLog: {
      title: 'Activity log',
      created: 'created this request',
      submitted: 'submitted for approval',
      approved: 'approved this request',
      rejected: 'rejected this request',
      edited: 'edited this request',
      attachmentAdded: 'added an attachment',
      commentAdded: 'added a comment',
      closed: 'closed this request',
      assigned: 'reassigned this request',
    },
    noActivity: 'No activity yet',
    pendingApprover: 'Pending assignment',
    rejectionReason: 'Rejection reason',
    editDraft: 'Edit Draft',
    deleteDraft: {
      title: 'Delete Draft',
      message:
        'Are you sure you want to delete this draft? This action cannot be undone.',
    },
    validation: {
      currencyRequired: 'Currency is required',
      expenseItemsRequired: 'At least one expense item is required',
      claimPeriodStartRequired: 'Claim period start date is required',
      claimPeriodEndRequired: 'Claim period end date is required',
      paymentMethodRequired: 'Payment method is required',
      materialsRequired: 'At least one material item is required',
      workersOrFinancialRequired:
        'At least one worker or financial data item is required',
      ewaSubTypeRequired: 'Sub-type is required',
      workersRequired: 'At least one worker is required',
      financialItemsRequired: 'At least one financial item is required',
      financialItemsRequiredWhenMarked:
        'Financial data is marked as present but no financial items have been added.',
      invoiceNotCollected:
        'Please verify in Priority whether the invoice has been collected.',
      financialRequestAmountRequired: 'Requested amount is required',
      financialRequestAmountPositive: 'Requested amount must be greater than 0',
      financialRequestForMonthRequired: 'Month is required',
      financialRequestInstallmentsRequired:
        'Number of installments is required',
      financialRequestReferredNameRequired: 'Referred person name is required',
      financialRequestReferredRoleRequired: 'Referred person role is required',
      financialRequestSubTypeRequired: 'Sub-type is required',
      leaveRequestDaysRequired: 'Number of days is required',
      leaveRequestDaysPositive: 'Number of days must be greater than 0',
      leaveRequestPeriodStartRequired: 'Start date is required',
      leaveRequestPeriodEndRequired: 'End date is required',
      leaveRequestPeriodEndInvalid: 'End date must be on or after start date',
      leaveRequestLastNameRequired: 'Last name is required',
      leaveRequestFirstNameRequired: 'First name is required',
    },
    worker: {
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter last name',
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter first name',
      role: 'Role',
      rolePlaceholder: 'Enter role',
      amount: 'Amount',
      addWorker: 'Add Worker',
      editWorker: 'Edit Worker',
    },
    financial: {
      documentNumber: 'Document No.',
      documentNumberPlaceholder: 'e.g. PQ25003035',
      documentDate: 'Document Date',
      valueWithoutVat: 'Value (excl. VAT)',
      invoiceNumber: 'Invoice No.',
      invoiceNumberPlaceholder: 'e.g. INV-2025-001',
      invoiceDate: 'Invoice Date',
      isInvoiced: 'Invoiced',
      isCollected: 'Collected',
      addFinancialItem: 'Add Financial Item',
      editFinancialItem: 'Edit Financial Item',
    },
    addNewIssuer: 'Add new issuer',
    addNewExpenseCategory: 'Add new expense category',
    addNewLastName: 'Add new last name',
    addNewFirstName: 'Add new first name',
    addNewRole: 'Add new role',
    addNewItemName: 'Add new item name',
    addNewMaterialDescription: 'Add new description',
    unitOfMeasure: {
      piece: 'Piece (pcs)',
      hour: 'Hour (hr)',
      day: 'Day',
      month: 'Month (mo)',
      kilogram: 'Kilogram (kg)',
      gram: 'Gram (g)',
      liter: 'Liter (L)',
      meter: 'Meter (m)',
      squareMeter: 'Square Meter (m²)',
      cubicMeter: 'Cubic Meter (m³)',
      package: 'Package (pkg)',
      box: 'Box',
      set: 'Set',
    },
    unitOfMeasureShort: {
      piece: 'pcs',
      hour: 'hr',
      day: 'day',
      month: 'mo',
      kilogram: 'kg',
      gram: 'g',
      liter: 'L',
      meter: 'm',
      squareMeter: 'm²',
      cubicMeter: 'm³',
      package: 'pkg',
      box: 'box',
      set: 'set',
    },
    export: {
      title: 'Export internal requests',
      buttonLabel: 'Export',
      fileName: 'File name',
      fileNameRequired: 'File name is required',
      startDate: 'Start date',
      endDate: 'End date',
      endDateAfterStart: 'End date must be on or after start date',
      types: 'Type',
      typesRequired: 'At least one type is required',
      statuses: 'Status',
      statusesRequired: 'At least one status is required',
      all: 'All',
      project: 'Project',
      allProjects: 'All projects',
      success: 'Export downloaded',
    },
  },
};
